import { useState, useEffect, useCallback } from 'react';

export function useSlider(total, autoPlayInterval = 4500) {
  const [current, setCurrent] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + total) % total);
  }, [total]);

  const goTo = useCallback((index) => {
    setCurrent(index);
  }, []);

  useEffect(() => {
    if (!isPlaying) return;
    const id = setInterval(next, autoPlayInterval);
    return () => clearInterval(id);
  }, [isPlaying, next, autoPlayInterval]);

  return { current, next, prev, goTo, isPlaying, setIsPlaying };
}

export default useSlider;
